// ESM-Huelle fuer lib/scripts/components/CMP_CFrame.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CFrame (id)
{
    this.construct (id);

    this.name = "CFrame";
    this.htmlType = "div";
    
    this.properties =
    {
        styles:
        {
            position: "absolute"
        }
    }
}

CFrame.prototype = new CComponent;
export { CFrame };
